import React from "react";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import {Objects, Parts} from "components";
import ObjectOverride from "components/ObjectOverride";
import API from "@beardeddevops/react.api";
import {Button} from "reactstrap";
import {confirmAlert} from "react-confirm-alert";
import UniversalModalOverride from "../UniversalModalOverride";
import WarningAlert from "../Elements/DispositionPendingWarningAlert";

/**
 *  @property {Accounts_Billings_Object} state
 *  @property {object} model
 *  @property {Accounts_Billings_Properties} model.properties
 *  @property {Accounts_Billings_Is} model.is
 *  @property {Accounts_Billings_Has} model.has
 */
class AccountBilling extends ObjectOverride {
	static propTypes = {
		...Framework.Components.Object.propTypes,
	};

	constructor(props) {
		super(props, Types.Accounts_Billings._name);
		this.update = API.RequestType.UPDATE;
	}


	async handleSubmit(event, suppressToast = false, suppressProcess = false) {
		this.update = API.RequestType.UPDATE;
		return super.handleSubmit(event, suppressToast, suppressProcess);
	}

	afterSubmit = () => {
		window.location.reload();
	}

	toggleAllLocationsArchived = () => {
		this.setState({AllLocationsArchived: !this.state.AllLocationsArchived});
	}

	// archiveAllLocations = () => {
	// 	confirmAlert({
	// 		title: 'Delete ALL Subscriptions',
	// 		message: 'Are you sure you want to DELETE  ALL of your SUBSCRIPTIONS? This will archive every location on your account. Note: This action is irreversible without contacting support. There will be a $200 fee per location to restore from a backup. Are you sure you want to DELETE your ENTIRE ACCOUNT?',
	// 		buttons: [
	// 			{
	// 				label: 'Yes',
	// 				onClick: async () => {
	// 					this.setState({loading: true});
	// 					let accModel = new API.BuildClass(Types.Accounts._name, API.RequestType.READ_ALL);
	// 					accModel.request = 'DELETE_ALL_LOCATIONS';
	// 					try {
	// 						await accModel.submit(null, 'DELETE_ALL_LOCATIONS');
	// 					} catch (e) {
	// 						// console.log("deleting", e)
	// 					}
	// 					this.setState({loading: false});
	// 					window.location.replace('/dashboard');
	// 				}
	// 			},
	// 			{
	// 				label: 'No',
	// 				onClick: async () => {
	// 				}
	// 			}
	// 		]
	// 	});
	//
	// }

	form = () => {
		/** @type {Accounts_Billings_Properties} properties */
		let properties = this.model.properties;
		/** @type {Accounts_Billings_Object} object */
		let object = this.state;
		return (
			<div>
				{this.props.rootState.all_locations_expired && <WarningAlert
					warningName={'No Active Subscriptions'}
					warningMessage={'Please correct Billing Information, and then resubscribe to a location, all locations currently have inactive subscriptions'}
					// color={}
					// textColor={this.props.rootState.persists_banner.MarketingForegroundColor}
					url={'https://' + window.location.href.split('//')[1].split('/')[0] + '/locations' }
					urlText={' Go to locations'}
					hideButton={true}
				/>}
				<div className={"row"}>

					<div className={"col-md-6 offset-3"}>

						{/*#region Card Information*/}

						<h4 className="section-title">Card Information</h4>

						{/*<div className={"row"}>*/}
						{/*	<div className={"col-md-8"}>*/}
						<div className="form-group">
							<Framework.Elements.TextField
								label={"Name on Card"}
								value={object.name}
								error={object.name_error}
								property={properties.name}
								update={this.handleTextFieldPropertyUpdate}
							/>
						</div>
						{/*	</div>*/}
						{/*	<div className={"col-md-4"}>*/}
						{/*		<div className="form-group">*/}
						{/*			<Framework.Elements.TextField*/}
						{/*				label={"Coupon Code"}*/}
						{/*				value={object.coupon}*/}
						{/*				error={object.coupon_error}*/}
						{/*				property={properties.coupon}*/}
						{/*				update={this.handleTextFieldPropertyUpdate}*/}
						{/*			/>*/}
						{/*		</div>*/}
						{/*	</div>*/}
						{/*</div>*/}
						<div className={"row"}>
							<div className={"col-md-5"}>
								<div className="form-group">
									<Framework.Elements.TextField
										label={"Card Number"}
										value={object.number}
										error={object.number_error}
										property={properties.number}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
							</div>
							<div className={"col-md-3"}>
								<div className="form-group">
									<Framework.Elements.TextField
										label={"Security Code / CVV"}
										value={object.verification_value}
										error={object.verification_value_error}
										property={properties.verification_value}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
							</div>
							<div className={"col-md-2"}>
								<div className="form-group">
									<Framework.Elements.TextField
										label={"Exp Month"}
										value={object.month}
										error={object.month_error}
										property={properties.month}
										update={this.handleTextFieldPropertyUpdate}
									/>

								</div>
							</div>
							<div className={"col-md-2"}>
								<div className="form-group">
									<Framework.Elements.TextField
										label={"Exp Year"}
										value={object.year}
										error={object.year_error}
										property={properties.year}
										update={this.handleTextFieldPropertyUpdate}
									/>

								</div>
							</div>
						</div>

						{/*#endregion*/}

						{/*#region Business Address*/}

						<h4 className="section-title">Billing Address</h4>
						<Parts.Address
							object={object}
							properties={properties}
							onTextUpdate={this.handleTextFieldPropertyUpdate}
							onSelectUpdate={this.handleSelectPropertyUpdate}
							hasCounty={false}
						/>

						{/*#endregion*/}

					</div>

				</div>
				<div className={'row'}>
					<div className={'col-md-3 offset-3 text-left'}>
						<span>
							<i style={{paddingRight: '5px'}} className="fa fa-cc-visa fa-2x"/>
							<i style={{paddingRight: '5px'}} className="fa fa-cc-mastercard fa-2x"/>
							<i style={{paddingRight: '5px'}} className="fa fa-cc-amex fa-2x"/>
							<i style={{paddingRight: '5px'}} className="fa fa-cc-discover fa-2x"/>
						</span>
					</div>
					<div className={'col-md-3 text-right'}>
						<img src="/assets/images/powered-by-stripe.png" style={{width: '100px'}}
						     alt={'FFL Boss Integration'}/>
					</div>

				</div>
			</div>
		)
	}

	render() {
		let hasModal = typeof this.props.hasModal !== 'undefined' ? this.props.hasModal : false;
		if (hasModal) {
			return this.form();
		}
		return (
			<Card style={{overflow: 'visible'}}>
				<CardContent style={{paddingBottom: 0}}>
					{this.form()}
					<hr style={{marginBottom: 0}}/>
				</CardContent>

				<CardActions style={{justifyContent: 'space-between', padding: '14px'}}>
					<UniversalModalOverride
						id={this.props.id}
						locations={rootState.locations}
						history={this.props.history}
						name={"All Locations Archived"}
						object={Objects.AllLocationsArchived}
						toggle={this.state.AllLocationsArchived}
						reportClose={this.reportClose('AllLocationsArchived')}
						size={"lg"}
						submitLabel={"Archive & Delete"}
						title={"Archive & Delete"}
						hideGoTo={true}
					/>
					{!this.props.rootState.user && <div>
						<Button color={'danger'} onClick={() => this.toggleAllLocationsArchived()} className="md-button header-btn">
							<i className={"fa fa-lock"}/>&nbsp;&nbsp;Delete All Account Subscriptions</Button>
					</div>}
					{this.dataIdSave ?
						<Button color="primary" data-id={this.dataIdSave} onClick={this.handleSubmit}>Save</Button>
						:
						<Button color="primary" onClick={this.handleSubmit}>Save</Button>
					}
				</CardActions>
			</Card>
		)
	}

}

export default Framework.Components.withRootState(AccountBilling);
